import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import { MissingPasswordModel } from "./missing-password.model";

/**
 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
 */
export namespace MissingPasswordAction {
	const ACTION_PREFIX = "[Missing Password]";

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	export const set = createAction(`${ACTION_PREFIX} Set`, (model: MissingPasswordModel) => ({ model }));
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	export const setSuccess = createAction(`${ACTION_PREFIX} Set Success`);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	export const setFail = createAction(`${ACTION_PREFIX} Set Fail`, (error: AppError) => ({ error }));
}
